<template>
  <div class="editor-container">
    <div v-if="editor" class="editor-toolbar">
      <v-tooltip text="Bold">
        <template v-slot:activator="{ props }">
          <button type="button" v-bind="props" @click="editor.chain().focus().toggleBold().run()" :class="{ 'is-active': editor.isActive('bold') }">
            <i class="fas fa-bold"></i>
          </button>
        </template>
      </v-tooltip>
      <v-tooltip text="Paragraph">
        <template v-slot:activator="{ props }">
          <button type="button" v-bind="props" @click="editor.chain().focus().setParagraph().run()" :class="{ 'is-active': editor.isActive('paragraph') }">
            <i class="fas fa-paragraph"></i>
          </button>
        </template>
      </v-tooltip>
      <v-tooltip text="Bullet List">
        <template v-slot:activator="{ props }">
          <button type="button" v-bind="props" @click="editor.chain().focus().toggleBulletList().run()" :class="{ 'is-active': editor.isActive('bulletList') }">
            <i class="fas fa-list-ul"></i>
          </button>
        </template>
      </v-tooltip>
      <v-tooltip text="Ordered List">
        <template v-slot:activator="{ props }">
          <button type="button" v-bind="props" @click="editor.chain().focus().toggleOrderedList().run()" :class="{ 'is-active': editor.isActive('orderedList') }">
            <i class="fas fa-list-ol"></i>
          </button>
        </template>
      </v-tooltip>
      <v-tooltip text="Undo">
        <template v-slot:activator="{ props }">
          <button type="button" v-bind="props" @click="editor.chain().focus().undo().run()">
            <i class="fas fa-undo"></i>
          </button>
        </template>
      </v-tooltip>
      <v-tooltip text="Redo">
        <template v-slot:activator="{ props }">
          <button type="button" v-bind="props" @click="editor.chain().focus().redo().run()">
            <i class="fas fa-redo"></i>
          </button>
        </template>
      </v-tooltip>
    </div>
    <editor-content :editor="editor" class="editor-content tiptap" @keydown.enter.prevent />
  </div>
</template>

<script setup>
import { useEditor, EditorContent } from '@tiptap/vue-3';
import StarterKit from '@tiptap/starter-kit';
import { TaskList } from '@tiptap/extension-task-list';
import { TaskItem } from '@tiptap/extension-task-item';
import { BulletList } from '@tiptap/extension-bullet-list';
import { OrderedList } from '@tiptap/extension-ordered-list';
import { ListItem } from '@tiptap/extension-list-item';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:modelValue']);

const editor = useEditor({
  content: props.modelValue,
  extensions: [
    StarterKit.configure({
      bulletList: false,
      orderedList: false,
      listItem: false,
    }),
    TaskList,
    TaskItem.configure({
      nested: true,
    }),
    BulletList,
    OrderedList,
    ListItem,
  ],
  onUpdate: ({ editor }) => {
    emit('update:modelValue', editor.getHTML());
  },
});
</script>

<style scoped lang="scss">
	@import "@/assets/styles/TipTapEditor.scss"
</style>